import styled from 'styled-components';

const CheckBoxMargin = styled.div`
  margin-top: 10px;
`;

export default CheckBoxMargin;
